export default __webpack_public_path__ + "static/media/SomeGuy_x1440.a3c3ba48.png";